import React from 'react';

import { getAppAdsM365MobileStyles } from '../../styles/ad-placement-components/app-ads-ad-placement-styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { OutlookPlacementBase } from '../responsive-ad-placements/responsive-outlook-placements';

export const AppAdsM365OutlookPlacement = withUAPLThemedStyles((props) => {
  const {
    placementData, // UAPVMSingleImagePlacement
    businessName,
    shortHeadline,
    isMultiLineShortHeadline,
    description,
    isMultiLineDescription,
    logo,
    finalUrl,
    displayUrl,
    i18n, // may need to set window._TL_ in other platforms
    classes,
    ...rest
  } = props;

  return (
    <div className={classes.preview}>
      <OutlookPlacementBase
        logo={logo}
        businessName={businessName}
        shortHeadline={shortHeadline}
        isMultiLineShortHeadline={isMultiLineShortHeadline}
        description={description}
        isMultiLineDescription={isMultiLineDescription}
        i18n={i18n}
        classes={classes}
        placementData={placementData}
        finalUrl={finalUrl}
        displayUrl={displayUrl}
        {...rest}
      />
    </div>

  );
}, getAppAdsM365MobileStyles, { componentName: 'AppAdsM365OutlookPlacement' });
